import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateMaintenanceEvent($companyId: ID!, $attributes: MaintenanceEventAttributes!) {
    createMaintenanceEvent(companyId: $companyId, attributes: $attributes) {
      maintenanceEvent {
        id
        ...CreatedMaintenanceEvent
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedMaintenanceEvent on MaintenanceEvent {
     id
     maintenanceType { id }
     asset { id }
  }
`
